export const JEV_OUTCOME_NO_EQUIVALENT = "no_equivalent";
export const JEV_OUTCOME_NEEDS_CONTEXT = "needs_context";
export const JEV_OUTCOME_ERROR = "error";

export const JEV_SUGGEST_LABEL = "Suggest";
export const JEV_SUGGESTION_COLUMN = "Suggestion";
export const JEV_ACCEPT_LABEL = "Accept";
export const JEV_SUGGESTS_PREFIX = "Jev suggests";
export const JEV_NO_EQUIVALENT_COPY = "Jev: no catalog match — create a new skill";
export const JEV_NEEDS_CONTEXT_COPY = "Jev could not determine a reliable match — search manually below";
export const JEV_SUGGEST_ERROR = "Could not get a Jev suggestion";
export const JEV_UNMAPPED_LIMIT = 200;
export const JEV_CATALOG_SEARCH_LIMIT = 80;
export const JEV_SKILL_SELECT_LIMIT = 60;
